<template>
	<div click.stop>
		<div class="modal is-active">
			<div class="modal-background" @click="cancel"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">
						{{ editFireProtection.id ? "Editera" : "Nytt" }} brandskydd
					</p>
					<button class="delete" aria-label="close" @click="cancel"></button>
				</header>
				<section class="modal-card-body">
					<div class="columns is-mobile" style="margin-bottom: 12px;">
						<div class="field">
							<label class="label">Brandskyddsnamn</label>
							<div class="control">
								<input
									type="text"
									v-model="fireProtection.name"
									class="input"
									placeholder="Brandskyddsnamn"
								/>
							</div>
						</div>
					</div>
					<div class="columns is-mobile" style="margin-bottom: 12px;">
						<div class="field has-multiselect column is-half">
							<label class="label">Grupp</label>
							<div class="control">
								<v-select
									class="panel-select narrow"
									v-model="chosenInventoryGroup"
									:options="fireProtectionGroupMap"
									:placeholder="'Välj typ'"
									:allowEmpty="false"
									:internalSearch="true"
									:showLabels="false"
									track-by="index"
									label="text"
								>
									<span slot="noResult">Inga resultat</span>
									<span
										slot="caret"
										slot-scope="{ toggle }"
										class="caret"
										@mousedown.prevent.stop="toggle()"
									><i class="fas fa-caret-down caret-inner"></i
									></span>
								</v-select>
							</div>
						</div>
						<div class="field has-multiselect column is-half">
							<label class="label">Typ</label>
							<div class="control">
								<v-select
									class="panel-select narrow"
									v-model="fireProtection.inventoryType"
									:options="types"
									:placeholder="'Välj typ'"
									:allowEmpty="false"
									:internalSearch="true"
									:showLabels="false"
								>
									<span slot="noResult">Inga resultat</span>
									<span
										slot="caret"
										slot-scope="{ toggle }"
										class="caret"
										@mousedown.prevent.stop="toggle()"
									><i class="fas fa-caret-down caret-inner"></i
									></span>
								</v-select>
							</div>
						</div>
					</div>
					<div class="field">
						<label class="label">Beskrivning</label>
						<div class="control">
							<textarea
								v-model="fireProtection.description"
								class="textarea"
								rows="2"
								placeholder="Beskrivning"
							/>
						</div>
					</div>
					<div class="field">
						<label class="label">Rekommendation</label>
						<div class="control">
							<textarea
								v-model="fireProtection.recommendation"
								class="textarea"
								rows="2"
								placeholder="Rekommendation"
							/>
						</div>
					</div>

					<div class="field ">
						<label class="label">Instruktion</label>
						<div class="control">
							<textarea
								v-model="fireProtection.instruction"
								class="textarea"
								rows="2"
								placeholder="Instruktion"
							/>
						</div>
					</div>
					<div class="field" v-if="$isAllowedTo('global_set_object_as_global')">
						<label class="label">Allmän</label>
						<SwitchButton v-model="globalVisibility" />
					</div>
				</section>
				<footer class="modal-card-foot">
					<button
						class="button is-dark"
						:class="isLoading ? 'is-loading' : ''"
						:disabled="disableSave"
						@click="save"
					>
						<span class="icon is-info"><i class="fas fa-save"/></span
						><span>Spara</span>
					</button>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import iconMixin from '@/mixins/iconMixin.js';

import SwitchButton from '@/components/switchButton.vue';

export default {
	components: {
		SwitchButton
	},
	mixins: [iconMixin],
	props: {
		editFireProtection: Object
	},
	data() {
		return {
			fireProtection: {
				name: '',
				description: '',
				recommendation: '',
				instruction: '',
				inventoryType: ''
			},
			isLoading: false,
			saveingError: false,
			companyOptions: [],
			fireProtectionGroupMap: [],
			chosenInventoryGroup: null,
			types: [],
			globalVisibility: false
		};
	},
	computed: {
		disableSave() {
			return !this.fireProtection.name;
		},
		...mapGetters('companyStore', ['companies']),
		...mapGetters('user', ['getActiveCompany', 'getActiveCustomer'])
	},
	methods: {
		...mapActions('companyStore', ['getCompanies']),
		save() {
			if (this.globalVisibility) {
				this.fireProtection.companyId = null;
				this.fireProtection.customerId = null;
			} else {
				if (this.fireProtection.companyId == null)
					this.fireProtection.companyId = this.getActiveCompany.id;

				this.fireProtection.customerId = this.getActiveCustomer.id;
			}

			if (!this.isLoading) {
				this.fireProtection.fireProtectionType = this.chosenInventoryGroup.index;
				this.$emit('save', this.fireProtection);
			}

			this.isLoading = true;
		},
		cancel() {
			this.$emit('cancel');
		}
	},
	created() {
		this.fireProtectionGroupMap = Object.values(
			this.getFireProtectionGroupMap()
		).map((item, index) => {
			return { index, text: item, isChecked: false };
		});
		this.fireProtectionGroupMap.unshift({ index: -1, text: 'Ej valt' });

		this.types = this.getFireProtectionTypes();

		if (this.editFireProtection) {
			Object.assign(this.fireProtection, this.editFireProtection);

			if (!this.fireProtection.inventoryType) {
				this.fireProtection.inventoryType = this.types[0];
			}
		}

		this.globalVisibility = this.fireProtection.companyId === null;

		this.chosenInventoryGroup = this.editFireProtection
			? this.fireProtectionGroupMap.filter(
				x => x.index == this.editFireProtection.fireProtectionType
			)
			: this.fireProtectionGroupMap[0];
	}
};
</script>

<style lang="scss" scoped>
.switch {
	margin-top: 0;
}
</style>
